import Actions from '../../action'
import BlazerStyle from '../../../config/blazer_style.json'

const initialState = {
    isLoading: false,
    error: false,
    selectedCombination: {
        style: BlazerStyle['style'].child[0],
        fit: BlazerStyle['fit'].child[0],
        sleeve_buttons: BlazerStyle['sleeve_buttons'].child[0],
        back_style: BlazerStyle['back_style'].child[0],
        pocket: BlazerStyle['pocket'].child[0],
        breast_pocket: BlazerStyle['breast_pocket'].child[0],
        lapels: BlazerStyle['lapels'].child[0],
        lapels_width: BlazerStyle['lapels_width'].child[0]
    },
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.UPDATE_BLAZER_STYLE: {
            const { selectedCombination } = state;
            return {
                ...state,
                selectedCombination: {
                    ...selectedCombination,
                    [action.key]: action.data,
                }
            };
        }
        case Actions.EDIT_BLAZER_STYLE: {
            return {
                ...state,
                selectedCombination: action.data,
            };
        } case Actions.RESET_CANVAS: {
            return {
                ...state,
                ...initialState
            }
        } case Actions.RESET_STYLE: {
            return {
                ...state,
                ...initialState
            }
        }
        default:
            return state;
    }

};